import { CustomRouteOption } from '~/apps/routes/RoutesTypes'
import { ADMIN_PATH, OPERATIONS_PATH } from '~/redux-modules/preferences'
import { suspend } from '~/apps/routes/utils'

const AdminUserQuotesPage = suspend(() => import('@Admin/AdminUserQuotesPage'))
const ProdWorkbenchExceptionFailureDetails = suspend(
    () => import('@ProdWb/ExceptionFailureDetails'),
)
const ProductionJobDetails = suspend(() => import('@ProdWb/JobDetails'))

const SalesOrderDetails = suspend(
    () => import('@OpsWb/SalesOrder/SalesOrderDetails'),
)
const JobDetails = suspend(() => import('@ProdWb/JobDetails'))
const UnbundledSalesOrders = suspend(() => import('@OpsWb/Production'))
const DownloadJobBundle = suspend(
    () => import('@ProdWb/JobDetails/components/DownloadBundle'),
)

/**
 * Function which returns route configs based on conditions
 * @param isAutoOTEnabled
 */
export const conditionalRoutes = ({
    isAutoOTEnabled,
}: {
    isAutoOTEnabled: boolean
}): CustomRouteOption[] => {
    const routes: CustomRouteOption[] = [
        {
            path: `${ADMIN_PATH}/user/:userId/orders`,
            element: <AdminUserQuotesPage />,
            privateRoute: true,
            verifyAdmin: true,
        },
    ]

    if (isAutoOTEnabled) {
        routes.push(
            ...[
                {
                    path: [
                        `${OPERATIONS_PATH}/production/exception-details/:name`,
                        `${OPERATIONS_PATH}/production/exception-details/:name/:tab/*`,
                    ],
                    element: <ProdWorkbenchExceptionFailureDetails />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: [
                        `${OPERATIONS_PATH}/production/job-details/:jobId`,
                        `${OPERATIONS_PATH}/production/job-details/:jobId/:tab`,
                    ],
                    element: <ProductionJobDetails />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: [
                        `${OPERATIONS_PATH}/production/sales-order-details/:saleOrderName`,
                        `${OPERATIONS_PATH}/production/sales-order-details/:saleOrderName/:tabs`,
                    ],
                    element: <SalesOrderDetails />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: `${OPERATIONS_PATH}/production/downloadJobBundle/:id`,
                    element: <DownloadJobBundle />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
            ],
        )
    } else {
        routes.push(
            ...[
                {
                    path: [
                        `${OPERATIONS_PATH}/scheduling/job-details/:jobId`,
                        `${OPERATIONS_PATH}/scheduling/job-details/:jobId/:tab`,
                    ],
                    element: <JobDetails />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: [
                        `${OPERATIONS_PATH}/scheduling/sales-order-details/:saleOrderName`,
                        `${OPERATIONS_PATH}/scheduling/sales-order-details/:saleOrderName/:tabs`,
                    ],
                    element: <SalesOrderDetails />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: [
                        `${OPERATIONS_PATH}/scheduling`,
                        `${OPERATIONS_PATH}/scheduling/:tab`,
                    ],
                    element: <UnbundledSalesOrders />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
                {
                    path: `${OPERATIONS_PATH}/scheduling/downloadJobBundle/:id`,
                    element: <DownloadJobBundle />,
                    privateRoute: true,
                    verifyAdmin: true,
                },
            ],
        )
    }

    return routes
}
